module.exports = __webpack_public_path__ + "img/672a866.jpg";